"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTcfConfig = void 0;
const configs_1 = require("./configs");
const getTcfConfig = (clientShortHandName, isProduction = true) => {
    return isProduction ? configs_1.prodTcfConfig[clientShortHandName] : configs_1.testTcfConfig[clientShortHandName];
};
exports.getTcfConfig = getTcfConfig;
